<template>
  <div class="seo-block">
    <div class="seo-block__inner">
      <div v-html="props.text" />
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps<{
    text: string;
  }>();
</script>

<style lang="scss" scoped>
  @use '@experience/shared/dist/assets/adaptivity';

  .seo-block {
    padding: var(--alias-space-48) 0 0 0;
    border-top: 1px solid var(--alias-color-border-default);
    color: var(--alias-color-text-default);
    font-size: 16px;

    @include adaptivity.tablet {
      padding-top: var(--alias-space-40);
    }

    @include adaptivity.mobile {
      padding-top: var(--alias-space-24);
    }
  }

  :deep(.seo-block__inner) {
    display: grid;
    gap: 32px;

    a {
      color: var(--alias-color-link-default);
      text-decoration: none;
    }

    h2 {
      max-width: 960px;
      margin: 0 0 16px;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
    }

    h3 {
      font-weight: 600;
    }

    p {
      max-width: 960px;
      margin: 12px 0;
      line-height: 24px;

      & + h2 {
        margin-top: 40px;
      }
    }

    ul {
      margin: 12px 0;
      padding: 0 24px;
      list-style: disc;

      li {
        margin: 4px 0 0;
        line-height: 24px;

        &:first-child {
          margin-top: 0;
        }
      }
    }

    @include adaptivity.mobile {
      h2 {
        margin: 0 0 12px;
        font-weight: 800;
        font-size: 20px;
        line-height: 28px;
      }

      p + h2 {
        margin-top: 32px;
      }
    }
  }
</style>
